/// <reference types="grecaptcha" />
import '@ts/pages/page-defaults';
const listener = (e) => {
    e.preventDefault();
    document.getElementById('submit-btn').disabled = true;
    document.getElementById('submit-btn').classList.add('processing');
    document.getElementById('agreeTerms').readOnly = true;
    document.getElementById('agreeMailAdvertising').readOnly = true;
    document.getElementById('password-confirm').readOnly = true;
    document.getElementById('password').readOnly = true;
    document.getElementById('email').readOnly = true;
    document.getElementById('last_name').readOnly = true;
    document.getElementById('first_name').readOnly = true;
    document.getElementById('register-form').setAttribute('disabled', 'true');
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let timezoneInput = document.createElement('input');
    timezoneInput.setAttribute('type', 'hidden');
    timezoneInput.setAttribute('name', 'timezone');
    timezoneInput.setAttribute('value', timeZone);
    document.getElementById('register-form').appendChild(timezoneInput);
    /// <reference types="grecaptcha" />
    grecaptcha.ready(function () {
        const sitekey = document.getElementById('recaptcha').getAttribute('data-sitekey') ?? '';
        grecaptcha.execute(sitekey, { action: 'register' }).then(function (token) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'captcharesponse');
            input.setAttribute('value', token);
            document.getElementById('register-form').appendChild(input);
            document.getElementById('register-form').submit();
        });
    });
};
document.getElementById('register-form').addEventListener('submit', listener);
function removeSubmitListener() {
    // console.log('removeSubmitListener');
    document.getElementById('register-form').removeEventListener('submit', listener);
}
